module.exports = __webpack_public_path__ + "img/pulcini.1b544790.jpg";